<template>
  <div class="lp">
    <div class="row mb-4">
          <div class="col-8">
            <h6>
              {{ $t("Customer Name") }} : {{ loyaltyData.firstName }}
              {{ " " }}
              {{ loyaltyData.lastName }}
            </h6>
            <h6 class="mb-3">
              {{ $t("mobileno") }} : {{ loyaltyData.mobileNo || "-" }}
            </h6>
          </div>
     
         
        </div>
    <div v-if="loading">
      <div class="top-bar">
        <div class="top-left">
          <div class="main-title">Club Loyalty</div>
          <div class="main-sub">Loyalty benefits &amp; redemptions</div>
        </div>
      </div>
      <div class="row d-flex justify-content-center my-2">
        <div
          class="text-center d-flex justify-content-center align-items-center p-3"
        >
          <div>
            <b-spinner variant="primary" label="Spinning"></b-spinner>
            <div class="font-weight-bold fs-16">
              Fetching Loyalty Benefits...
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="lp-inner">
      <div class="top-bar">
        <div class="top-left">
          <div class="main-title">Club Loyalty</div>
          <div class="main-sub">Loyalty benefits &amp; redemptions</div>
        </div>

        <div class="stat-grid">
          <div class="stat">
            <div class="stat-label">Spend pts</div>
            <div class="stat-val accent">
              {{ parseInt(loyaltyData.customer.spend_points || 0) }}
            </div>
          </div>
          <div class="stat">
            <div class="stat-label">Pts used</div>
            <div class="stat-val" :class="pointsUsed > 0 ? 'used' : ''">
              {{ parseInt(pointsUsed) }}
            </div>
          </div>
          <div class="stat">
            <div class="stat-label">Pts left</div>
            <div
              class="stat-val"
              :class="remainingPoints < 0 ? 'danger' : 'ok'"
            >
              {{ parseInt(remainingPoints) }}
            </div>
          </div>
          <div class="stat">
            <div class="stat-label">Tier pts</div>
            <div class="stat-val">
              {{ parseInt(loyaltyData.customer.tier_points || 0) }}
            </div>
          </div>
          <div class="stat">
            <div class="stat-label">Tier</div>
            <div class="stat-val tier-text">
              {{ loyaltyData.customer.tier_name || "-" }}
            </div>
          </div>
        </div>
      </div>

      <div class="pts-bar-wrap" v-if="availablePoints > 0">
        <div class="pts-bar-track">
          <div
            class="pts-bar-fill"
            :style="{
              width: Math.min(100, (pointsUsed / availablePoints) * 100) + '%'
            }"
            :class="{ 'pts-bar-fill--over': pointsUsed > availablePoints }"
          ></div>
        </div>
        <div class="pts-bar-label">
          {{ pointsUsed }} / {{ availablePoints }} pts used
        </div>
      </div>

      <div class="lp-body">
        <template
          v-if="customer && loyaltyData.sections && loyaltyData.sections.length"
        >
          <div v-for="section in sortedSections" :key="section.section_id">
            <div class="sec-label">{{ section.display_name }}</div>

            <template v-if="section.section_name === 'Redemption'">
              <div
                v-for="rule in section.orderedRules"
                :key="(isItemEligible(rule) ? 'r-' : 'nr-') + rule.program_id + '-' + rule.benefit_ref_id"
                class="b-row"
                :class="{
                  'b-row--eligible': isItemEligible(rule),
                  'b-row--disabled': !isItemEligible(rule)
                }"
              >
                <div class="b-left">
                  <div class="b-lbl" :class="{ strike: !isItemEligible(rule) }">
                    {{ rule.label }}
                  </div>
                  <div class="chips">
                    <span class="chip ch-entity">{{ rule.entity_name }}</span>
                    <span v-if="rule.points_cost" class="chip ch-pts"
                      >{{ rule.points_cost }} pts each</span
                    >
                    <span
                      v-if="rule.offer_value && rule.is_percent"
                      class="chip ch-pts"
                      >{{ rule.offer_value }}% off</span
                    >
                    <template v-if="isItemEligible(rule)">
                      <span v-if="isInCart(rule)" class="chip ch-ok"
                        >✓ in cart ({{ cartCountFor(rule) }})</span
                      >
                      <span v-else class="chip ch-warn">not in cart</span>
                    </template>
                    <span v-else class="na-tag">Not applicable</span>
                    
                    <span v-if="rule.limit_per_month" class="chip ch-cap"
                      >{{ rule.used_this_month }}/{{ rule.limit_per_month }} this month</span
                    >
                  </div>
                  
                  <template v-if="isItemEligible(rule)">
                    <div v-if="getQty(rule) > 0 && !isInCart(rule)" class="v-warn">
                      ⚠ This item is not in your cart
                    </div>
                    <div
                      v-if="getQty(rule) >= cartCountFor(rule) && cartCountFor(rule) > 0 && getQty(rule) === maxAllowedQty(rule)"
                      class="v-info"
                    >
                      Max cart quantity reached ({{ cartCountFor(rule) }})
                    </div>
                  </template>
                  <div v-if="!isItemEligible(rule) && rule.ineligible_reason" class="b-reason">
                    {{ rule.ineligible_reason }}
                  </div>
                </div>
              </div>
            </template>

            <template v-if="section.section_name === 'TierBenefits'">
              <div
                v-for="benefit in section.orderedBenefits"
                :key="(isItemEligible(benefit) ? 'b-' : 'nb-') + benefit.benefit_ref_id"
                class="b-row"
                :class="{
                  'b-row--eligible': isItemEligible(benefit),
                  'b-row--disabled': !isItemEligible(benefit)
                }"
              >
                <div class="b-left">
                  <div class="b-lbl" :class="{ strike: !isItemEligible(benefit) }">
                    {{ benefit.label }}
                  </div>
                  <div class="chips">
                    <span class="chip ch-entity">{{ benefit.entity_name }}</span>
                    <span v-if="benefit.offer_value" class="chip ch-pts"
                      >{{ benefit.offer_value }}% off</span
                    >
                    <template v-if="isItemEligible(benefit)">
                      <span v-if="isInCart(benefit)" class="chip ch-ok"
                        >✓ in cart ({{ cartCountFor(benefit) }})</span
                      >
                      <span v-else class="chip ch-warn">not in cart</span>
                    </template>
                    <span v-else class="na-tag">Not applicable</span>

                    <span v-if="benefit.period_cap" class="chip ch-cap"
                      >limit {{ benefit.period_cap }}/{{ benefit.qty_period }}</span
                    >
                  </div>
                  <div
                    v-if="benefit.applicable_days && benefit.applicable_days.length < 7"
                    class="days-row"
                  >
                    <span
                      v-for="(d, i) in dayLabels"
                      :key="i"
                      class="day"
                      :class="{ 'day--on': benefit.applicable_days.includes(i) }"
                      >{{ d }}</span
                    >
                  </div>
                  <div
                    v-if="isItemEligible(benefit) && getQty(benefit) === maxAllowedQty(benefit) && maxAllowedQty(benefit) > 0"
                    class="v-info"
                  >
                    Max quantity reached ({{ maxAllowedQty(benefit) }})
                  </div>
                  <div v-if="!isItemEligible(benefit) && benefit.ineligible_reason" class="b-reason">
                    {{ benefit.ineligible_reason }}
                  </div>
                </div>
              </div>
            </template>
          </div>
        </template>

        <div
          v-else-if="customer && !loyaltyData.sections.length"
          class="empty-state"
        >
          No loyalty data available for this customer.
        </div>

        <div v-if="validationErrors.length" class="v-summary">
          <div
            v-for="(err, i) in validationErrors"
            :key="i"
            class="v-summary-row"
          >
            ⚠ {{ err }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClubLoyaltySummary",

  props: {
    benefits: {
      type: Object,
      default: () => ({ customer: {}, sections: [] })
    },
    loading: {
      type: Boolean,
      default: false
    },

    selectedTickets: {
      type: Array,
      default: () => []
    },
    selectedFnb: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      quantities: {},
      dayLabels: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
    };
  },

  computed: {
    loyaltyData() {
      return this.benefits || { customer: {}, sections: [] };
    },
    customer() {
      return this.loyaltyData.customer || {};
    },
    availablePoints() {
      return this.loyaltyData.customer.spend_points || 0;
    },
    sortedSections() {
      if (!this.loyaltyData.sections) return [];

      return this.loyaltyData.sections.map(section => {
        const cloned = { ...section };

        if (cloned.section_name === "Redemption" && cloned.programs) {
          // 1. Gather ALL rules from ALL programs into a single flat array
          let allRules = [];
          cloned.programs.forEach(program => {
            if (program.rules) {
              allRules.push(...program.rules);
            }
          });

          // 2. Separate rules into eligible and non-eligible groups globally
          const applicable = allRules.filter(rule => this.isItemEligible(rule));
          const nonApplicable = allRules.filter(rule => !this.isItemEligible(rule));

          // 3. Attach unified sorted list directly onto the section level
          cloned.orderedRules = [...applicable, ...nonApplicable];
        }

        if (cloned.section_name === "TierBenefits" && cloned.benefits) {
          const benefitsList = cloned.benefits || [];
          const applicable = benefitsList.filter(b => this.isItemEligible(b));
          const nonApplicable = benefitsList.filter(b => !this.isItemEligible(b));
          
          cloned.orderedBenefits = [...applicable, ...nonApplicable];
        }

        return cloned;
      });
    },
    pointsUsed() {
      if (!this.loyaltyData || !this.loyaltyData.sections) return 0;
      let total = 0;

      this.loyaltyData.sections.forEach(section => {
        // Collect points from raw properties or computed properties safely
        const rules = [];
        if (section.programs) {
          section.programs.forEach(p => {
            if (p.rules) rules.push(...p.rules);
          });
        }
        if (section.orderedRules) {
          rules.push(...section.orderedRules);
        }
        
        // De-duplicate items by key if any exist in both arrays
        const uniqueItems = Array.from(new Set(rules));

        uniqueItems.forEach(rule => {
          if (rule && rule.points_cost) {
            total += this.getQty(rule) * rule.points_cost;
          }
        });

        const benefits = section.benefits || section.orderedBenefits || [];
        benefits.forEach(benefit => {
          if (benefit && benefit.points_cost) {
            total += this.getQty(benefit) * benefit.points_cost;
          }
        });
      });
      return total;
    },
    remainingPoints() {
      return this.availablePoints - this.pointsUsed;
    },
    totalTicketsInCart() {
      return this.selectedTickets.length;
    },
    totalFnbInCart() {
      return this.selectedFnb.length;
    },
    totalTicketBenefitQtyUsed() {
      if (!this.loyaltyData) return 0;
      let used = 0;
      this.loyaltyData.sections.forEach(section => {
        const items = [];
        if (section.programs) {
          section.programs.forEach(p => {
            if (p.rules) items.push(...p.rules);
          });
        }
        if (section.orderedRules) items.push(...section.orderedRules);
        if (section.benefits) items.push(...section.benefits);
        if (section.orderedBenefits) items.push(...section.orderedBenefits);

        const uniqueItems = Array.from(new Set(items));
        uniqueItems.forEach(item => {
          if (item.entity_name === "TICKET") used += this.getQty(item);
        });
      });
      return used;
    },
    totalFnbBenefitQtyUsed() {
      if (!this.loyaltyData) return 0;
      let used = 0;
      this.loyaltyData.sections.forEach(section => {
        const items = [];
        if (section.programs) {
          section.programs.forEach(p => {
            if (p.rules) items.push(...p.rules);
          });
        }
        if (section.orderedRules) items.push(...section.orderedRules);
        if (section.benefits) items.push(...section.benefits);
        if (section.orderedBenefits) items.push(...section.orderedBenefits);

        const uniqueItems = Array.from(new Set(items));
        uniqueItems.forEach(item => {
          if (item.entity_name === "FNB") used += this.getQty(item);
        });
      });
      return used;
    },
    validationErrors() {
      const errors = [];
      if (this.remainingPoints < 0) {
        errors.push(
          `Insufficient points: need ${this.pointsUsed} pts but only ${this.availablePoints} pts available.`
        );
      }
      if (this.totalTicketBenefitQtyUsed > this.totalTicketsInCart) {
        errors.push(
          `Ticket benefits (${this.totalTicketBenefitQtyUsed}) exceed tickets in cart (${this.totalTicketsInCart}).`
        );
      }
      if (this.totalFnbBenefitQtyUsed > this.totalFnbInCart) {
        errors.push(
          `F&B benefits (${this.totalFnbBenefitQtyUsed}) exceed F&B items in cart (${this.totalFnbInCart}).`
        );
      }
      return errors;
    }
  },

  watch: {
    customer() {
      this.quantities = {};
    }
  },

  methods: {
    isItemEligible(item) {
      if (!item) return false;
      const flag = item.eligible !== undefined ? item.eligible : item.is_eligible;
      return flag === true || flag === 'true';
    },
    itemKey(item) {
      if (!item) return "default_key";
      const prefix = item.benefit_type || item.benefit_ref_id || "type";
      const suffix = item.benefit_ref_id || item.id || "id";
      return `${prefix}_${suffix}`;
    },
    getQty(item) {
      return this.quantities[this.itemKey(item)] || 0;
    },
    cartCountFor(item) {
      if (item.entity_name === "TICKET") {
        if (item.product_code === "ALL") return this.totalTicketsInCart;
        return this.selectedTickets.filter(t => t.sstg_id == item.product_code)
          .length;
      }
      if (item.entity_name === "FNB") {
        if (item.product_code === "ALL") return this.totalFnbInCart;
        return this.selectedFnb.filter(f => f.item_code == item.product_code)
          .length;
      }
      return 0;
    },
    maxAllowedQty(item) {
      const limits = [];
      if (item.max_qty) limits.push(item.max_qty);
      if (item.limit_per_transaction) limits.push(item.limit_per_transaction);
      if (item.period_cap) limits.push(item.period_cap);
      const inCartCount = this.cartCountFor(item);
      if (inCartCount > 0) limits.push(inCartCount);
      if (item.points_cost && item.points_cost > 0) {
        const otherPointsUsed =
          this.pointsUsed - this.getQty(item) * item.points_cost;
        const pointsLeft = this.availablePoints - otherPointsUsed;
        const affordableQty = Math.floor(pointsLeft / item.points_cost);
        limits.push(Math.max(0, affordableQty));
      }
      if (item.entity_name === "TICKET") {
        const otherTicketQty =
          this.totalTicketBenefitQtyUsed - this.getQty(item);
        const remainingSlots = this.totalTicketsInCart - otherTicketQty;
        limits.push(Math.max(0, remainingSlots));
      }
      if (item.entity_name === "FNB") {
        const otherFnbQty = this.totalFnbBenefitQtyUsed - this.getQty(item);
        const remainingSlots = this.totalFnbInCart - otherFnbQty;
        limits.push(Math.max(0, remainingSlots));
      }
      return limits.length ? Math.min(...limits) : 9;
    },
    isIncrementBlocked(item) {
      return this.getQty(item) >= this.maxAllowedQty(item);
    },
    increment(item) {
      if (!this.isItemEligible(item) || this.isIncrementBlocked(item)) return;
      const k = this.itemKey(item);
      this.$set(this.quantities, k, (this.quantities[k] || 0) + 1);
    },
    decrement(item) {
      const k = this.itemKey(item);
      const cur = this.quantities[k] || 0;
      if (cur <= 0) return;
      this.$set(this.quantities, k, cur - 1);
    },
    isInCart(item) {
      if (item.entity_name === "TICKET") {
        if (item.product_code === "ALL") return true;
        return this.selectedTickets.some(t => t.sstg_id == item.product_code);
      }
      if (item.entity_name === "FNB") {
        if (item.product_code === "ALL") return true;
        return this.selectedFnb.some(f => f.item_code == item.product_code);
      }
      return true;
    }
  }
};
</script>

<style scoped>
.lp {
  --c-bg: #ffffff;
  --c-surf: #f7f6f4;
  --c-border: #e4e2de;
  --c-border-md: #ccc9c4;
  --c-text: #1a1917;
  --c-text2: #6b6762;
  --c-text3: #b0ada8;
  --c-accent: #534ab7;
  --c-accent-dark: #3c3489;
  --c-accent-bg: #eeedfe;
  --c-accent-mid: #cecbf6;
  --c-ok: #27500a;
  --c-ok-bg: #eaf3de;
  --c-warn: #633806;
  --c-warn-bg: #faeeda;
  --c-danger: #791f1f;
  --c-danger-bg: #fcebeb;
  --r: 10px;
  --r-sm: 6px;
  color: var(--c-text);
  background: var(--c-bg);
  max-height: calc(100vh - 230px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.lp-inner {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.lp-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 8px;
}

.top-bar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}
.top-left {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.main-title {
  font-size: 22px;
  font-weight: 600;
  color: var(--c-text);
}
.main-sub {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--c-text3);
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
}
.stat {
  background: var(--c-surf);
  border-radius: var(--r-sm);
  padding: 8px 12px;
  min-width: 80px;
}
.stat-label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--c-text3);
  margin-bottom: 3px;
}
.stat-val {
  font-size: 18px;
  font-weight: 600;
  color: var(--c-text);
  line-height: 1;
}
.stat-val.accent {
  color: var(--c-accent);
}
.stat-val.used {
  color: var(--c-warn);
}
.stat-val.ok {
  color: var(--c-ok);
}
.stat-val.danger {
  color: var(--c-danger);
}
.stat-val.tier-text {
  font-size: 13px;
  margin-top: 3px;
}

.pts-bar-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}
.pts-bar-track {
  flex: 1;
  height: 5px;
  background: var(--c-surf);
  border-radius: 99px;
  overflow: hidden;
  border: 1px solid var(--c-border);
}
.pts-bar-fill {
  height: 100%;
  background: var(--c-accent);
  border-radius: 99px;
  transition: width 0.3s ease;
}
.pts-bar-fill--over {
  background: var(--c-danger);
}
.pts-bar-label {
  font-size: 11px;
  color: var(--c-text2);
  white-space: nowrap;
}

.sec-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--c-text3);
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 18px 0 10px;
}
.sec-label::after {
  content: "";
  flex: 1;
  height: 1px;
  background: var(--c-border);
}

.b-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border: 1px solid var(--c-border);
  border-radius: var(--r);
  margin-bottom: 8px;
  background: var(--c-bg);
  transition: border-color 0.13s;
}
.b-row:hover:not(.b-row--disabled) {
  border-color: var(--c-border-md);
}
.b-row--eligible {
  border-left: 3px solid var(--c-accent);
}
.b-row--disabled {
  background: var(--c-surf);
  border-color: var(--c-border);
}
.b-left {
  flex: 1;
  min-width: 0;
}
.b-lbl {
  font-size: 14px;
  font-weight: 500;
  color: var(--c-text);
  line-height: 1.35;
  margin-bottom: 7px;
}
.b-lbl.strike {
  text-decoration: line-through;
  color: var(--c-text3);
  font-weight: 400;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
.chip {
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 4px;
  font-weight: 500;
}
.ch-entity {
  background: var(--c-accent-bg);
  color: var(--c-accent-dark);
}
.ch-pts {
  background: var(--c-surf);
  color: var(--c-text2);
  border: 1px solid var(--c-border);
}
.ch-ok {
  background: var(--c-ok-bg);
  color: var(--c-ok);
}
.ch-warn {
  background: var(--c-warn-bg);
  color: var(--c-warn);
}
.ch-cap {
  background: var(--c-surf);
  color: var(--c-text3);
  border: 1px solid var(--c-border);
}

.b-reason {
  font-size: 11px;
  color: var(--c-text3);
  margin-top: 6px;
  font-style: italic;
}

.v-warn {
  font-size: 11px;
  color: var(--c-warn);
  margin-top: 5px;
}
.v-info {
  font-size: 11px;
  color: var(--c-text3);
  margin-top: 5px;
}

.days-row {
  display: flex;
  gap: 3px;
  margin-top: 7px;
}
.day {
  font-size: 10px;
  padding: 2px 5px;
  border-radius: 3px;
  background: var(--c-surf);
  color: var(--c-text3);
  border: 1px solid var(--c-border);
}
.day--on {
  background: var(--c-accent-bg);
  color: var(--c-accent);
  border-color: var(--c-accent-mid);
}

.b-right {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.pts-tag {
  font-size: 12px;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: var(--r-sm);
  background: var(--c-accent-bg);
  color: var(--c-accent);
  white-space: nowrap;
}
.na-tag {
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 4px;
  background: var(--c-surf);
  color: var(--c-text3);
  border: 1px solid var(--c-border);
  white-space: nowrap;
  font-weight: 500;
}

.v-summary {
  margin-top: 14px;
  padding: 10px 14px;
  background: var(--c-danger-bg);
  border: 1px solid #f7c1c1;
  border-radius: var(--r-sm);
}
.v-summary-row {
  font-size: 12px;
  color: var(--c-danger);
  margin-bottom: 4px;
}
.v-summary-row:last-child {
  margin-bottom: 0;
}

.empty-state {
  padding: 28px;
  text-align: center;
  font-size: 13px;
  color: var(--c-text2);
  font-style: italic;
}
</style>